<template>
  <div class="sm:px-4 lg:px-8">
    <div class="container flex flex-col gap-4 pt-4 lg:gap-6 lg:pt-6">
      <LegacyPageProfileTabs v-bind="tabs" />

      <NuxtPage />
    </div>
  </div>
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp();
const locale = nuxtApp.$i18n.global.locale;
const mappedLocale = computed(() => reverseLocaleMap(locale.value));
const translate = nuxtApp.$i18n.global.t;

const tabs = ref({
  tabs: {
    current: "",
    default: "",
    rootPath: `/${mappedLocale.value}/terms`,
    items: [
      { name: translate("site.terms.tabService"), slug: "" },
      { name: translate("site.terms.tabContent"), slug: "content" },
      { name: translate("site.terms.tabSubscriptions"), slug: "subscriptions" },
      { name: translate("site.terms.tabContest"), slug: "contest" },
      {
        name: translate("site.terms.tabCreatorRewards"),
        slug: "creatorrewards",
      },
      { name: translate("site.terms.tabPrivacy"), slug: "privacy" },
      { name: translate("site.terms.tabCookie"), slug: "cookie" },
    ],
  },
});

const desc = ref(
  "These Terms of Service constitute a legally binding agreement.",
);

useHead({
  meta: [{ name: "description", content: desc }],
});
</script>
